import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import appConfig from '@/config/appConfig.typed';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {ensureGoogleTagManagerInjected} from '@/services/analytics/ga/googleTagManagerBootstrap';
import {selectIsGaEnabled} from '@/state/selectors/consumerAggregatedSettings';

const useGoogleAnalytics = () => {
    const isGaEnabled = useSelector(selectIsGaEnabled);
    const googleTagManagerId = appConfig.getGoogleTagManagerId();
    const oneTrustDomainScriptId = appConfig.getOneTrustDomainScriptId();

    useEffect(() => {
        googleAnalyticsService.toggleAnalytics(isGaEnabled);
    }, [isGaEnabled]);

    useEffect(() => {
        if (!googleTagManagerId || oneTrustDomainScriptId) return;

        ensureGoogleTagManagerInjected();
    }, [googleTagManagerId, oneTrustDomainScriptId]);
};

export default useGoogleAnalytics;
